import React from 'react';
import PropTypes from 'prop-types';
import {BASE_TEXT} from '../../../style/typography';
import {TARMAC} from '../../../style/colors';
import glamorous from 'glamorous';
import {formatCount} from '../../../utils/format';
import {PHONE} from '../../../style/breakpoints';
import StatsCard from '../../../library/cards/stats';
import HackerNewsIcon from '../../../library/icons/social/hacker-news.svg';
import RedditIcon from '../../../library/icons/social/reddit.svg';
import StackOverflowIcon from '../../../library/icons/social/stack-overflow.svg';
import {MOBILE_PADDING} from '../card';

const DESKTOP_ICON_SIZE = 28;
const MOBILE_ICON_SIZE = 25;

const DESKTOP_MARGIN = 45;
const MOBILE_MARGIN = 25;

const iconStyles = {
  height: DESKTOP_ICON_SIZE,
  width: DESKTOP_ICON_SIZE,
  [PHONE]: {
    height: MOBILE_ICON_SIZE,
    width: MOBILE_ICON_SIZE
  }
};

const StyledHackerNewsIcon = glamorous(HackerNewsIcon)(iconStyles);

const StyledRedditIcon = glamorous(RedditIcon)(iconStyles);

const StyledStackOverflowIcon = glamorous(StackOverflowIcon)(iconStyles);

const Container = glamorous.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  [PHONE]: {
    padding: MOBILE_PADDING
  },
  ' > div > div': {
    marginLeft: DESKTOP_MARGIN,
    [PHONE]: {
      marginLeft: MOBILE_MARGIN
    }
  }
});

const Placeholder = glamorous.div({
  ...BASE_TEXT,
  color: TARMAC
});

const SourceStatsCard = ({
  hackerNews = 0,
  reddit = 0,
  stackOverflow = 0,
  placeholder = 'No Stats'
}) => {
  let items = [];
  if (hackerNews > 0) {
    items.push({
      icon: <StyledHackerNewsIcon />,
      stat: formatCount(hackerNews),
      label: 'Hacker News Points'
    });
  }
  if (reddit > 0) {
    items.push({icon: <StyledRedditIcon />, stat: formatCount(reddit), label: 'Reddit Points'});
  }
  if (stackOverflow > 0) {
    items.push({
      icon: <StyledStackOverflowIcon />,
      stat: formatCount(stackOverflow),
      label: 'Stack Overflow Questions'
    });
  }
  return (
    <Container>
      {items.length > 0 ? (
        <StatsCard tooltip={true} items={items} />
      ) : (
        <Placeholder>{placeholder}</Placeholder>
      )}
    </Container>
  );
};

SourceStatsCard.propTypes = {
  hackerNews: PropTypes.number,
  reddit: PropTypes.number,
  stackOverflow: PropTypes.number,
  placeholder: PropTypes.string
};

export default SourceStatsCard;
